import {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import ThemeToggle from "../Theme/ThemeToggle";
import styles from './Navbar.module.css';

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
    const menuRef = useRef(null);
    const menuToggleRef = useRef(null);

    useEffect(() => {
        document.documentElement.className = theme;
        localStorage.setItem("theme", theme);
    }, [theme]);

    // Закрытие меню при клике вне его
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Проверяем, кликнули ли мы вне мобильного меню и вне кнопки меню
            if (menuOpen && menuRef.current && !menuRef.current.contains(event.target) && menuToggleRef.current && !menuToggleRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        // Добавляем обработчик события при клике на документ
        document.addEventListener("mousedown", handleClickOutside);

        // Убираем обработчик при размонтировании компонента
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <>
            <nav className={styles.navbar}>
                {/* Левая часть */}
                <div className={styles.navbarLeft}>
                    <Link to="/">
                        <div className={styles.navItem}>Главная</div>
                    </Link>
                    <Link to="/projects">
                        <div className={styles.navItem}>Проекты</div>
                    </Link>
                    <Link to="/cv">
                        <div className={styles.navItem}>Резюме</div>
                    </Link>
                </div>

                {/* Правая часть */}
                <div className={styles.navbarRight}>
                    {/* Кнопка смены темы */}
                    <ThemeToggle theme={theme} setTheme={setTheme}/>
                </div>
            </nav>
            <div className={styles.navbarSpacer}></div>
        </>
    );
}
